/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud # Usage This API is used in the `https://yrityksille.elisa.fi/` pages. # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InstallmentTerm } from './installmentTerm.js';
import { InstallmentOption } from './installmentOption.js';


/**
 * Defines the pricing structure for an offering. priceType indicates the charge type: OC = One-Time Charge, RC = Recurring Charge, UC = Usage Charge.
 */
export interface ProductOfferingPrice { 
    /**
     * A unique ID for each price entry.
     */
    id?: string;
    /**
     * Type of charge: OC = One-Time Charge, RC = Recurring Charge, UC = Usage Charge.
     */
    priceType: ProductOfferingPrice.PriceTypeEnum;
    /**
     * Price excluding tax.
     */
    priceWithoutTax?: number;
    /**
     * Price including tax.
     */
    priceWithTax?: number;
    /**
     * Tax percentage applied to the price.
     */
    taxPercentage?: number;
    /**
     * Optional list of installment plans available for this price (e.g., for OC device pricing). Each entry describes the per-installment amount for a given number of installments.
     */
    installmentOption?: Array<InstallmentOption>;
    /**
     * Optional list of installment Terms available for EPP. Each entry describes the per-installment amount for a given number of installments.
     */
    installmentTerm?: Array<InstallmentTerm>;
    /**
     * Optional upfront downpayment amount associated with the price. May be null if no downpayment is required.
     */
    downpaymentAmount?: number;
}
export namespace ProductOfferingPrice {
    export type PriceTypeEnum = 'OC' | 'RC' | 'UC';
    export const PriceTypeEnum = {
        OC: 'OC' as PriceTypeEnum,
        RC: 'RC' as PriceTypeEnum,
        UC: 'UC' as PriceTypeEnum
    };
}


